import { ReactSDKClient } from '@optimizely/react-sdk'
import { UserInfo } from '@optimizely/react-sdk/dist/utils'
import cloneDeep from 'lodash/cloneDeep'
import isEqual from 'lodash/isEqual'

import { WSUSER_COOKIE } from '@/constants'
import { getCookie } from '@/utils/cookies'

/*
NOTE: Custom hook to set Optimizely user attributes relevant to the Production Page
*/

const useOptimizelyUser = (
    optimizely: ReactSDKClient | null,
    state: string | undefined,
    performerId: number | undefined,
    categoryId: number,
    subCategoryId: number,
): UserInfo | undefined => {
    const user = cloneDeep(optimizely?.user)
    if (user?.attributes) {
        user.attributes.production_visitor = true
        user.attributes.event_category = categoryId
        user.attributes.event_subcategory = subCategoryId
        user.attributes.venue_state = state
        user.attributes.performer_id = performerId
        if (typeof document !== 'undefined') {
            user.attributes.ws_user = !!getCookie(document.cookie, WSUSER_COOKIE)
        }
        if (!isEqual(user, optimizely?.user)) {
            optimizely?.setUser(user)
        }
    }

    return user
}

export default useOptimizelyUser
